import { Link } from "react-router-dom";
import getImageUrl from "../utils/getImageUrl";

export default function ArticleCard({ article, user, onDeleted }) {
  // Fallback to placeholder if no image exists
  const imageSrc = article.image
    ? getImageUrl(article.image)
    : getImageUrl("Placeholder.png");

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!window.confirm("Delete this article permanently?")) return;

    onDeleted(article.id);
  };

  return (
    <Link to={`/articles/${article.id}`} className="article-link">
      <div className="article-card">
        <img
          src={imageSrc}
          alt={article.title}
          className="article-image"
        />

        <h3>{article.title}</h3>

        <p className="byline">
          By {article.author} •{" "}
          {new Date(article.created_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })} • {" "}{article.category}
        </p>

        <p className="description">{article.description}</p>

        {(user?.role === "admin" || user?.role === "superadmin") && (
          <button
            className="admin-delete-btn"
            onClick={handleDeleteClick}
            title="Delete article"
          >
            🗑
          </button>
        )}
      </div>
    </Link>
  );
}
